// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3SfPA","label":"Completed_label__3JUNq"};